import React, { useContext } from 'react';

import docusignImg from '../assets/images/docusign.png';
import Layout from '../components/common/Layout';
import { UserContext } from '../context/UserContext';
import { getDocuSignLink } from '../service/api';

const DocuSignPage = () => {
  const { setLoading } = useContext(UserContext);

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const res = await getDocuSignLink();
      if (res && res.data && res.data.url) {
        window.location.href = res.data.url;
      }
    } catch (e) {
      console.error(e);
    }

    setLoading(false);
  };

  return (
    <Layout>
      <div className="review-page">
        <h1 className="title">Docusign</h1>
        <div className="imageDiv">
          <img src={docusignImg} />
        </div>
        <div className="need-docs-header">
          <h3 className="subtitle">
            Please click the button below to proceed to DocuSign to execute your agreement
            documents. <br /> <br />
            The agreement is not active until the document is digitally signed via DocuSign.
          </h3>
        </div>
        <div className="one-button">
          <button className="primary-btn" onClick={handleSubmit}>
            Continue to Docusign
          </button>
        </div>
      </div>
    </Layout>
  );
};

export default DocuSignPage;
